import React, { memo } from 'react';

import { Segmented } from 'antd';

import { Languages, LanguagesType } from 'context';

export interface ICvLanguagePicker {
  value: Languages;
  onChange: (language: Languages) => void;
}

/**
 * POL / ENG switcher for the CV text section and the PDF download.
 *
 * Russian was retired from the offer — the market is Polish, and the backend
 * `save_cv_text` now rejects it. CVs written while it was still offered stay in
 * the database and still render and download; they simply cannot be edited.
 */
export const CvLanguagePicker = memo(({ value, onChange }: ICvLanguagePicker) => (
  <Segmented
    value={value}
    onChange={(next) => onChange(next as Languages)}
    options={[
      { value: Languages.polish, label: LanguagesType.POL },
      { value: Languages.english, label: LanguagesType.ENG },
    ]}
  />
));
